export default __webpack_public_path__ + "static/media/insta19.ad6681c5.webp";